<template>
    <main class="app-container">
        <div :style="`height: ${height}px;`">


            <list-loading v-show="listData.loading && listData.query.page == 1" />
            <div class="no-result" v-show="!listData.loading && listData.data.length < 1">没有报名记录~ <router-link to="/courses">查看课程</router-link></div>
            <md-scroll-view
                    ref="scrollView"
                    :scrolling-x="false"
                    @end-reached="onReachBottom"
            >
                <md-field v-for="item in listData.data"
                          :key="item.id"
                          :title="'订单号：'+item.no">
                    <md-detail-item title="课程编号" :content="item.course_no" />
                    <md-detail-item title="地点" :content="item.place" />
                    <md-detail-item title="日期" :content="`${item.start_day} ~ ${item.end_day} ${item.week_day}`" />
                    <md-detail-item title="时间" :content="`${item.start_time}至${item.end_time}`" />
                    <md-detail-item title="Leader" :content="item.leader_name" />
                    <md-detail-item title="监护人" :content="item.caregiver_name + '/' + item.caregiver_tel" />
                    <md-detail-item title="参与儿童" :content="item.children" />
                    <md-detail-item title="课程包" :content="item.course_package_name ? item.course_package_name : '---'" />
                    <!--<md-detail-item title="费用" :content="item.amount_total" />-->
                    <md-detail-item title="报名时间" :content="item.created_at" />
                    <md-detail-item class="operation" title="">
                        <router-link :to="'/enroll-review/'+item.id" v-if="!item.reviewed">点评</router-link>
                        <router-link :to="{ name: 'courses-show', params: { id: item.course_id }}">课程详情</router-link>
                    </md-detail-item>
                </md-field>

                <md-scroll-view-more
                        slot="more"
                        finished-text=""
                        :is-finished="listData.hasNextPage == false"
                >
                </md-scroll-view-more>
            </md-scroll-view>
        </div>


        <md-landscape v-model="showFullScreen" full-screen>
            <enroll-detail></enroll-detail>
        </md-landscape>
    </main>
</template>

<script>
import { Field, DetailItem,Landscape,ScrollView, ScrollViewMore } from 'mand-mobile'
import EnrollDetail from "../components/EnrollDetail.vue";
import ListLoading from "../components/ListLoading.vue";
import listDataMixin from "../mixins/list-data";

export default {
    name: "enroll-history",
    components: {
        [Field.name]: Field,
        [DetailItem.name]: DetailItem,
        [Landscape.name]: Landscape,
        [ScrollView.name]: ScrollView,
        [ScrollViewMore.name]: ScrollViewMore,
        EnrollDetail,ListLoading,
    },
    mixins: [listDataMixin],

    data() {
        return {
            apiEndpoint: 'enrolls/my',
            showFullScreen:false,
            height: window.screen.height,
        }
    },
    methods: {
        showDetail(id) {
            this.showFullScreen = true;
        }
    },
    created() {
        this.loadListData();
    },
};
</script>


<style lang="scss" scoped>
.md-field{
    margin-bottom: 20px;
}

</style>
